/* application entry point */

import React from "react"
import ReactDOM from "react-dom"
import App from "./components/App"
import "98.css"
import "./App.css"

ReactDOM.render(<App />, document.getElementById("root"))
